export const STATE_DEFAULT = {
    apiData: {},
    appBannerData: {},
    bottomMenuData: {},
    cinemaData: {},
    cliData: {},
    extraBottomMenuData: {},
    multisiteSelector: {},
    routesData: {},
    siteHeaderData: {},
    topMenuData: {},
    translation: {}
}

// Main keys
export const APIDATA = 'apiData'
export const APPBANNERDATA = 'appBannerData'
export const BOTTOMMENUDATA ="bottomMenuData"
export const CINEMADATA = 'cinemaData'
export const CLI = 'cliData'
export const EXTRABOTTOMMENUDATA = 'extraBottomMenuData'
export const MULTISITESELECTOR = 'multisiteSelector'
export const ROUTESDATA = 'routesData'
export const SITEHEADERDATA = 'siteHeaderData'
export const TOPMENUDATA = 'topMenuData'
export const TRANSLATION = 'translation'
export const UI = 'ui'

// Sub Keys
export const PROGRAM_CINEMAS = 'cinemas'
export const PROGRAM_MOVIES = 'movies'
export const PROGRAM_MOVIES_ITEMS = 'moviesItems'
export const PROGRAM_MOVIES_ORDER = 'moviesOrder'
export const PROGRAM_ATTRIBUTES = 'attributes'
export const PROGRAM_ADS = 'ads'
export const PROGRAM_HIGHLIGHTS = 'highlights'
export const PROGRAM_WEISCHERADS = 'weischerAds'
export const PROGRAM_SELECTIONS_ITEMS = 'itemSelections'
export const PROGRAM_COLLECTIONS_ITEMS = 'itemCollections'
export const PROGRAM_SELECTIONSDISPLAY = 'itemSelectionsDisplay'
export const PROGRAM_SELECTIONSDISPLAY_ITEMS = 'itemSelectionsDisplayItems'
export const PROGRAM_SELECTIONSDISPLAY_ORDER = 'itemSelectionsDisplayOrder'
export const PROGRAM_ADVERTISEMENTS = 'advertisements'
export const PROGRAM_ADVERTISEMENTS_ITEMS = 'advertisementsItems'
export const PROGRAM_ADVERTISEMENTS_ORDER = 'advertisementsOrder'
export const PROGRAM_ELBENWALDARTICLES_ITEMS = 'elbenWaldArticlesItems'

export const SITE = 'wpSite'
export const FRONT_MOBILE_SETTINGS = 'wpFrontMobileSettings'
export const FRONT = 'wpFront'
export const FEATURES = 'wpFeatures'
export const THEME = 'wpTheme'
export const LOGO ="wpLogo"
export const SOCIALMEDIA = "wpSocialMedia"
export const ADVERTISEMENT_CONFIG = "wpAdvertisementConfig"

export const CLI_MULTICINEMA_MODE = 'cliMulticinemaMode'
export const CLI_CURRENT_CINEMA_ID = 'cliCurrentCinemaId'
export const CLI_CINEMA_CLIENT_ID = 'cliCinemaClientId'

export const UI_TRAILER = 'uiTrailer'

// Data Keys

export const DATA_KEY_PATHS = {
    [APIDATA]:                              [APIDATA],
    [PROGRAM_CINEMAS]:                      [APIDATA, 'cinemas', 'items'],
    [PROGRAM_MOVIES]:                       [APIDATA, 'movies'],
    [PROGRAM_MOVIES_ITEMS]:                 [APIDATA, 'movies', 'items'],
    [PROGRAM_MOVIES_ORDER]:                 [APIDATA, 'movies', 'order'],
    [PROGRAM_ATTRIBUTES]:                   [APIDATA, 'attributes'],
    [PROGRAM_ADS]:                          [APIDATA, 'ads', 'items'],
    [PROGRAM_HIGHLIGHTS]:                   [APIDATA, 'highlights', 'items'],
    [PROGRAM_WEISCHERADS]:                  [APIDATA, 'weischerAds', 'items'],
    [PROGRAM_SELECTIONS_ITEMS]:             [APIDATA, 'itemSelections', 'items'],
    [PROGRAM_COLLECTIONS_ITEMS]:            [APIDATA, 'itemCollections', 'items'],
    [PROGRAM_SELECTIONSDISPLAY]:            [APIDATA, 'itemSelectionsDisplay'],
    [PROGRAM_SELECTIONSDISPLAY_ITEMS]:      [APIDATA, 'itemSelectionsDisplay', 'items'],
    [PROGRAM_SELECTIONSDISPLAY_ORDER]:      [APIDATA, 'itemSelectionsDisplay', 'order'],
    [PROGRAM_ADVERTISEMENTS]:               [APIDATA, 'advertisements'],
    [PROGRAM_ADVERTISEMENTS_ITEMS]:         [APIDATA, 'advertisements', 'items'],
    [PROGRAM_ADVERTISEMENTS_ORDER]:         [APIDATA, 'advertisements', 'order'],
    [PROGRAM_ELBENWALDARTICLES_ITEMS]:      [APIDATA, 'elbenwaldArticles', 'items'],

    [APPBANNERDATA]:                        [APPBANNERDATA],
    
    [BOTTOMMENUDATA]:                       [BOTTOMMENUDATA],

    [CINEMADATA]:                           [CINEMADATA],
    [SITE]:                                 [CINEMADATA, 'site'],
    [FRONT_MOBILE_SETTINGS]:                [CINEMADATA, 'front_mobile_setting'],
    [FRONT]:                                [CINEMADATA, 'front'],
    [FEATURES]:                             [CINEMADATA, 'features'],
    [THEME]:                                [CINEMADATA, 'theme'],
    [LOGO]:                                 [CINEMADATA, 'logo'],
    [SOCIALMEDIA]:                          [CINEMADATA, 'socialmedia'],
    [ADVERTISEMENT_CONFIG]:                 [CINEMADATA, 'advertisement_config'],
    
    [CLI]:                                  [CLI],
    [CLI_MULTICINEMA_MODE]:                 [CLI, 'multiCinemaMode'],
    [CLI_CURRENT_CINEMA_ID]:                [CLI, 'currentCinemaId'],
    [CLI_CINEMA_CLIENT_ID]:                 [CLI, 'cinemaClientId'],

    [EXTRABOTTOMMENUDATA]:                  [EXTRABOTTOMMENUDATA],
    
    [MULTISITESELECTOR]:                    [MULTISITESELECTOR],
    
    [ROUTESDATA]:                           [ROUTESDATA],

    [SITEHEADERDATA]:                       [SITEHEADERDATA],

    [TOPMENUDATA]:                          [TOPMENUDATA],

    [TRANSLATION]:                          [TRANSLATION],
    
    [UI]:                                   [UI],
    [UI_TRAILER]:                           [UI, 'trailer'],
}
